// @flow

import _ from 'lodash';
import { ADDONS_INFO, ANALYTICS_ADDON_NAME } from 'src/constants/subscription';
import { getUTCDate, getEndOfDate } from 'src/helpers/date-time-helper';
import { buildDateFromDateRange } from 'src/helpers/analytics-helpers';
import { I18n } from '@shopify/react-i18n';
import { store } from 'src/stores/store';
import { getShop } from 'src/helpers';
import { dynamicActionAnalytic } from 'src/helpers/analytics-v3-helpers';

/**
 * Check if the store show analytic v2 or not ?
 * @param {*} tenantApp
 * @returns
 */
export const enableAnalyticV2 = tenantApp => {
  const enableAnalyticV2 = _.get(tenantApp, 'settings.analyticV2.settings.enable', false);
  return enableAnalyticV2;
};

/**
 * Check if the store show analytic v2 for Recommendation or not ?
 * @param {*} tenantApp
 * @returns
 */
export const enableAnalyticV2Recommendation = () => {
  return true;
};

/**
 * Check if the store show analytic v2 setting or not ?
 * @param {*} tenantApp
 * @returns
 */
export const enableAnalyticV2Settings = () => {
  return true;
};

/**
 * Get current addon infos is using and status addon analytics
 * @param {*} invoice
 * @param {*} addonStatus
 * @returns
 */
export const getAddonAnalyticInfos = (invoice: Object, addonStatus: Object, featureAnalytics) => {
  const currentAddon = Object.keys(featureAnalytics).find(
    key => key.includes('analytics') && featureAnalytics[key] === true
  );
  const subscribed = currentAddon && !_.isEmpty(currentAddon);

  const subscribedBefore = _.get(addonStatus, 'subscribedBefore', false);

  const includedPackage = _.get(addonStatus, 'includedPackage', false);
  let subscribedAddon = _.get(addonStatus, 'addOnInfo', {});
  // Get infos addon analytics from package
  if (_.isEmpty(subscribedAddon) && includedPackage) {
    const packageName = _.get(invoice, 'chargeInfo.name', '');
    if (packageName.includes('essential')) {
      subscribedAddon = {
        addOnName: 'analytics-90-days'
      };
    }
    if (packageName.includes('professional')) {
      subscribedAddon = {
        addOnName: 'analytics-180-days'
      };
    }
  }

  // Get addon name if addon is trial
  if (_.isEmpty(subscribedAddon)) {
    subscribedAddon = _.get(addonStatus, 'trialInfo', {});
  }

  //  Get add on infos
  let addonInfo = ADDONS_INFO.find(e => e.name === ANALYTICS_ADDON_NAME);
  addonInfo = {
    ...addonInfo,
    addonName: _.get(subscribedAddon, 'addOnName', null)
      ? _.get(subscribedAddon, 'addOnName', null)
      : addonInfo?.name
  };

  return {
    subscribed: subscribed || includedPackage,
    subscribedBefore,
    addonInfo
  };
};

/**
 * Init data analytic to storage
 * TTL 15min
 */
export const initAnalyticDataToStorage = async (
  i18n: I18n
): Promise<{
  topSearchTerms: Array<any>,
  topProducts: Array<any>
}> => {
  const data = getAnalyticDataFromStorage();

  if (!_.isEmpty(data)) {
    const now = Math.round(Date.now() / 1000);
    // Keep the data in 15 minutes
    console.log(now - data?.createdAt);
    if (now - data?.createdAt <= 15 * 60) {
      return { topProducts: data.topProducts, topSearchTerms: data.topSearchTerms };
    }
  }

  const { selectedDates } = buildDateFromDateRange('last7Days');
  const fromDateUTC = getUTCDate(selectedDates.start, 0, 0, 0);
  const toDateUTC = getUTCDate(getEndOfDate(selectedDates.end), 24, 0, 0, 0);

  const [topSearchTermsResult, topProductsResult] = await Promise.all([
    store.dispatch(
      dynamicActionAnalytic('getListTopSearchTerms', fromDateUTC, toDateUTC, false, null, 30, i18n)
    ),
    store.dispatch(
      dynamicActionAnalytic('getTopProductsOnSearch', fromDateUTC, toDateUTC, false, null, 30, i18n)
    )
  ]);

  const topProducts = topProductsResult?.payload?.data?.data?.slice(0, 10);
  const topSearchTerms = topSearchTermsResult?.payload?.data?.data?.slice(0, 10);

  const storageKey = `${getShop()}:analytic-v2:last7days`;
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        topProducts,
        topSearchTerms,
        createdAt: Math.round(Date.now() / 1000)
      })
    );
  } catch (error) {
    // console.log(error);
  }

  return {
    topProducts,
    topSearchTerms
  };
};

/**
 * Get data analytic from storage
 */
export const getAnalyticDataFromStorage = (): {
  topSearchTerms: Array<any>,
  topProducts: Array<any>
} => {
  const storageKey = `${getShop()}:analytic-v2:last7days`;
  let parseData = {};
  try {
    const data = localStorage.getItem(storageKey) || {};
    parseData = JSON.parse(data);
  } catch (error) {
    // console.log({ error });
    parseData = {};
  }

  return parseData;
};

/**
 * Cancel request api analytic
 */
export const onAbortApiAnalytic = () => {
  if (window.abortApiAnalyticController) {
    window.abortApiAnalyticController.abort();
  }
  window.abortApiAnalyticController = new AbortController();
};
